import type {
    UtmSourceEnum,
    UtmMediumEnum,
    UtmContentEnum,
} from '@/Shared/Service/Tracking/Utm/UtmEnums'
import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export class UtmParameters {
    constructor(
        public readonly source: UtmSourceEnum,
        public readonly medium: UtmMediumEnum | null,
        public readonly content: UtmContentEnum | null,
    ) {
        ensureNoUndefinedProperties(this)
    }
}
